import { GET_CONTACT, GET_CONTACT_SUCCESS } from "../../constants/ActionTypes";

export const getContact = () => {
  return {
    type: GET_CONTACT
  };
};
export const getContactSuccess = (data) => {
  return {
    type: GET_CONTACT_SUCCESS,
    payload: data,
  };
};
